import React from 'react'

import { Card, CardHeading, CardContent } from '@components/layout/Card'
import { LineChartStacked } from '@components/charts/LineChartStacked'

import { Text } from '@UILibrary/Text'
import { buildLineChartjsStackedOptionsProp } from './charts/options'
import { buildFinancialHealthHeatmapDataProp } from './charts/data'

interface FinancialHealthDistribution {
  labels: string[]
  datasets: any[]
}

interface FinancialHealthHeatmapByPercentageProps {
  financialHealthDistribution: FinancialHealthDistribution
}

export const FinancialHealthHeatmapByPercentage: React.FC<FinancialHealthHeatmapByPercentageProps> = (props) => {
  const { labels, datasets } = props.financialHealthDistribution
  const datasetsWithColors = buildFinancialHealthHeatmapDataProp(datasets)

  return (
    <Card>
      <CardHeading>
        <Text heading4a colour="secondary-main" as="h3" margin="none">
          Is your team set up for safe retirement?
        </Text>
        <Text body as="p">
          Percentage of employees in each safe retirement status.
        </Text>
      </CardHeading>
      <CardContent>
        <LineChartStacked
          height="medium"
          labels={labels}
          data={datasetsWithColors}
          options={buildLineChartjsStackedOptionsProp(labels, datasetsWithColors)}
        />
        <Text bodySmall as="p" textAlign='center' margin='none'>
          (click legends to toggle on and off)
        </Text>
      </CardContent>
    </Card>
  )
}
